<template>
  <v-app>
    <v-main
      class="main-bg darken-4 d-flex align-center justify-center"
      style="min-height: 100vh"
    >
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="pa-5" rounded>
              <v-card-title class="justify-center text-h6 font-weight-bold">
                {{ $t("login_title") }}
              </v-card-title>

              <v-card-text>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                  @submit.prevent="handleLogin"
                >
                  <v-text-field
                    v-model="email"
                    :label="$t('email')"
                    :rules="[rules.required]"
                    outlined
                    dense
                    required
                  />

                  <v-text-field
                    v-model="password"
                    :label="$t('password')"
                    :rules="[rules.required]"
                    type="password"
                    outlined
                    dense
                    required
                  />

                  <div
                    class="d-flex justify-space-between align-center mt-1 mb-3"
                  >
                    <v-checkbox
                      v-model="remember"
                      :label="$t('remember_me')"
                      dense
                      hide-details
                      class="ma-0 pa-0"
                    />
                  </div>

                  <v-btn
                    block
                    color="amber darken-2"
                    class="mt-5"
                    type="submit"
                    :loading="loading"
                  >
                    {{ $t("login_button") }}
                  </v-btn>
                </v-form>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import api from "../services/axios";
import { mapActions } from "vuex";

export default {
  name: "UserLogin",
  data() {
    return {
      email: "",
      password: "",
      remember: false,
      loading: false,
      valid: false,
      rules: {
        required: (v) => !!v || this.$t("field_required"),
      },
    };
  },
  mounted() {
    const saved = localStorage.getItem("lang");
    if (saved) this.changeLang(saved);
  },
  methods: {
    ...mapActions(["login"]),
    async handleLogin() {
      const isFormValid = await this.$refs.form.validate();
      if (!isFormValid) return;

      this.loading = true;
      try {
        const res = await api.post("/auth/login", {
          email: this.email,
          password: this.password,
        });
        if (!res.data.status) {
          this.$root.$emit("show-snackbar", {
            message: this.$te(res.data.locale_key) ? res.data.locale_key : res.data.message,
            color: "error",
          });
        } else {
          this.login({
            user: res.data.data,
            token: res.data.data.access_token,
          });
          
          this.$root.$emit("show-snackbar", {
            message: this.$te(res.data.locale_key) ? res.data.locale_key : res.data.message,
            color: "success",
          });
          const permissions = res.data.data.permission;
          const permissionObj = permissions.find(p => p.name === "Home");
          if (!permissionObj || permissionObj.permission === 0) {
            this.$router.push("/dashboard/no-permission");
          }
          else {
            this.$router.push("/dashboard/home");
          }
        }
      } catch (error) {
        if(error.response)
        this.$root.$emit("show-snackbar", {
          message: this.$te(error.response.data.locale_key) ? error.response.data.locale_key : error.response.data.message,
          color: "error",
        });
      } finally {
        this.loading = false;
      }
    },
    changeLang(lang) {
      this.$i18n.locale = lang;
      document.dir = lang === "ar" ? "rtl" : "ltr";
      this.$vuetify.rtl = lang === "ar";
    },
  },
};
</script>

<style scoped>
.text-caption {
  font-size: 0.75rem;
}
</style>
